import { Tooltip } from "react-tooltip"
/*
For detailed usage instructions, see https://react-tooltip.com/docs/getting-started
*/
export default Tooltip
